import { z } from 'zod';
import { get } from 'svelte/store';
import { _ } from 'svelte-i18n';

export class RouteTypeValidator {
    private errors: string[] = [];

    getErrors(): string[] {
        console.log(this.errors);
        return this.errors;
    }

    isAllValid(): boolean {
        return this.errors.length === 0;
    }

    checkVehicleLoad(value: string): string[] {
        let min = 0;
        let max = 11.5;
        let errors: string[] = [];
        if (z.coerce.number().safeParse(value).success === false) {
            errors.push(get(_)('Axle load must be a number'));
        }
        if (z.coerce.number().min(min).max(max).safeParse(value).success === false) {
            errors.push(get(_)('Axle load must be in range {min} - {max}', { values: { min, max } }));
        }
        this.errors = [...errors];
        return errors;
    }

    checkVehicleHeight(value: string): string[] {
        let min = 0;
        let max = 4.1;
        if (z.coerce.number().safeParse(value).success === false) {
            return [get(_)('Vehicle height must be a number')];
        }
        if (z.coerce.number().min(min).max(max).safeParse(value).success === false) {
            return [get(_)('Vehicle height must be in range {min} - {max}', { values: { min, max } })];
        }
        return [];
    }

    checkVehicleWidth(value: string): string[] {
        let min = 0;
        let max = 2.6;
        if (z.coerce.number().safeParse(value).success === false) {
            return [get(_)('Vehicle width must be a number')];
        }
        if (z.coerce.number().min(min).max(max).safeParse(value).success === false) {
            return [get(_)('Vehicle width must be in range {min} - {max}', { values: { min, max } })];
        }
        return [];
    }

    checkVehicleLength(value: string): string[] {
        let min = 0;
        let max = 18;
        if (z.coerce.number().safeParse(value).success === false) {
            return [get(_)('Vehicle length must be a number')];
        }
        if (z.coerce.number().min(min).max(max).safeParse(value).success === false) {
            return [get(_)('Vehicle length must be in range {min} - {max}', { values: { min, max } })];
        }
        return [];
    }

    checkVehicleWeight(value: string): string[] {
        let min = 0;
        let max = 40;
        if (z.coerce.number().safeParse(value).success === false) {
            return [get(_)('Vehicle weight must be a number')];
        }
        if (z.coerce.number().min(min).max(max).safeParse(value).success === false) {
            return [get(_)('Vehicle weight must be in range {min} - {max}', { values: { min, max } })];
        }
        return [];
    }

    checkRouteStartTime(value: string): string[] {
        if (value && !value.match(/^\d{1,2}:\d{2}$/)) {
            return [get(_)('Departure time must be in format hh:mm')];
        }
        return [];
    }
}
